import React from 'react'
import { Link } from 'react-router-dom'
import styled from '../../config/theme'

export default function InputView ({
  label,
  value,
  color,
  url,
}: InputViewProps) {
  return (
    <Container>
      <Label>{label}</Label>
      {url ? (
        <Value
          as={Link}
          to={url}
          color="darkBlue"
        >
          {value}
        </Value>
      ) : (
        <Value
          color={color}
        >
          {value}
        </Value>
      )}
    </Container>
  )
}

export interface InputViewProps {
  label: string
  value: string | number | null
  color?: string
  url?: string
}

const Container = styled.div`
  position: relative;
  border: 1px solid #ececec;
  padding: 11px 10px;
  color: #7c8798;
  border-radius: 2px;
`

const Label = styled.div`
  position: absolute;
  font-size: 11px;
  bottom: 100%;
  left: 10px;
  background-color: #fff;
  padding: 0 3px;
  transform: translateY(40%);
`

const Value = styled.div<{ color?: string }>`
  font-size: 15px;
  ${props => props.color && `color: ${props.color};`}
`
